import React, { } from "react";
import { Pie } from "@ant-design/plots";

function PieChart({
    customColor = false,
    data = [],
    chartConfig = {},
    style = {}
}) {
    const colorList = data.reduce((acc, item) => {
        acc[item.name] = item.color;
        return acc;
    }, {});

    const config = {
        appendPadding: 10,
        data,
        angleField: "value",
        colorField: "type",
        radius: 0.8,
        label: {
            type: "inner ",
            content: "{name} {percentage}"
        },
        interactions: [
            {
                type: "pie-legend-active"
            },
            {
                type: "element-active"
            }
        ],
        legend: {
            position: "bottom",
            flipPage: false
        },
        ...chartConfig
    };
    if (customColor) {
        config.color = ({ type }) => colorList[type];
    }
    return (
        <div className="pie-chart" style={{ height: "100%", width: "100%", ...style }}>
            <Pie {...config} />
        </div>
    );
}

export default PieChart;
